// extracted by mini-css-extract-plugin
export default {"sizes":"\"../../cssvariables/media.module.css\"","mobile-to":"screen and (min-width : 320px)","visuallyHidden":"utils_visuallyHidden__SIGvw","button":"styles_button__eRbnB"};